import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import * as nodeOps from '../../../api/Tasks/task-node-operations';

const ConnParamCreateMapServerElementCheck = ({
  selectedNode,
  showMapServerElementCheck,
  updateFieldsToShow
}) => {
  if (!showMapServerElementCheck) return '';
  if (!nodeOps.isMapServerElementAllowed(selectedNode)) return '';
  return (
    <Form.Check
      type="checkbox"
      id="createMapServerElement"
      name="createMapServerElement"
      defaultChecked={nodeOps.shouldCreateMapServerElement(selectedNode)}
      label="Create Layer Server"
      onChange={event => updateFieldsToShow(event)}
    />
  );
};
ConnParamCreateMapServerElementCheck.propTypes = {
  selectedNode: PropTypes.object.isRequired,
  showMapServerElementCheck: PropTypes.bool.isRequired,
  updateFieldsToShow: PropTypes.func.isRequired
};

export default ConnParamCreateMapServerElementCheck;
